import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function CalloutButton({
  buttonText,
  buttonUrl,
  onClick,
  size,
  use = 'secondary'
}) {
  if (!buttonUrl) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      size: size,
      use: use,
      children: buttonText
    });
  }
  const ecosystemUrlPattern = /^https:\/\/ecosystem\.hubspot(qa)?\.com\/marketplace(.*)$/;
  const match = buttonUrl.match(ecosystemUrlPattern);
  if (match) {
    const parsed = new URL(buttonUrl);
    const routerPath = parsed.pathname.replace('/marketplace', '') || '/';
    const hasUtmParams = Array.from(parsed.searchParams.keys()).some(param => param.startsWith('utm'));
    if (hasUtmParams) {
      return /*#__PURE__*/_jsx(Button, {
        href: buttonUrl,
        onClick: onClick,
        size: size,
        use: use,
        children: buttonText
      });
    }
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "stretch",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        disabled: false,
        external: false,
        onClick: onClick,
        responsive: true,
        size: size,
        to: routerPath,
        truncate: false,
        type: "button",
        use: use,
        children: buttonText
      })
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    external: true,
    href: buttonUrl,
    onClick: onClick,
    size: size,
    use: use,
    children: buttonText
  });
}